import { Users, MapPin, Clock } from "lucide-react";
import { HeroConfig } from "@/config/heroConfig";

interface HeroStatsProps {
  stats: HeroConfig['stats'];
}

const iconMap = {
  Users,
  MapPin,
  Clock
};

export const HeroStats = ({ stats }: HeroStatsProps) => {
  return (
    <div className="flex flex-col xs:flex-row flex-wrap gap-4 xs:gap-6 justify-center lg:justify-start">
      {stats.map((stat, index) => {
        const IconComponent = iconMap[stat.icon as keyof typeof iconMap];
        return (
          <div key={index} className="flex items-center text-white/90 justify-center xs:justify-start">
            <IconComponent className="w-5 h-5 mr-2 text-accent flex-shrink-0" />
            <span className="font-semibold text-sm xs:text-base">{stat.text}</span>
          </div>
        );
      })}
    </div>
  );
};